module.exports = __webpack_public_path__ + "static/media/correct.66830e02.mp3";